var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M19.25 7.478a2.73 2.73 0 0 0-2.727-2.728H7.478A2.73 2.73 0 0 0 4.75 7.478v9.044a2.73 2.73 0 0 0 2.728 2.728h9.044a2.73 2.73 0 0 0 2.728-2.727zm1.5 9.044a4.23 4.23 0 0 1-4.227 4.228H7.478a4.23 4.23 0 0 1-4.228-4.227V7.478A4.23 4.23 0 0 1 7.478 3.25h9.044a4.23 4.23 0 0 1 4.228 4.228z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M15.25 12a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 0 0 6.5 0m1.5 0a4.75 4.75 0 1 1-9.5 0 4.75 4.75 0 0 1 9.5 0m.634-4.901a.474.474 0 0 1-.474.473v.552c-.531 0-.969-.404-1.021-.92l-.005-.105.005-.106c.052-.517.49-.92 1.021-.92v.551l.095.01a.475.475 0 0 1 .379.465"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M17.936 7.099c0 .566-.46 1.025-1.026 1.025v-.552a.474.474 0 0 1-.465-.379l-.009-.094.01-.096a.475.475 0 0 1 .464-.379v-.552c.567 0 1.026.46 1.026 1.027"
  })));
};
export default SvgInstagram;